import en from '../languages/en/index';
import fr from '../languages/fr/index';
export default { en, fr }